import React, { useEffect, useState } from "react";
import ModalBasic from "../../component/FormModal";
import SectionWithBorder from "../../../components/membership/membershipTaskList/SectionWithBorder";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import moment from "moment";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import BoardOfDirectors from "../../../components/membershipTasksProcess/BoardOfDirectors";
import OrdinaryProjectsCompleted from "../../../components/membershipTasksProcess/OrdinaryProjectsCompleted";
import ValidationText from "../../../utils/validation/ValidationText";

const MembershipTaskListProcess = (props) => {

  const hasStatusFour =
    props.membershipCommitteeApproval?.some(
      item => Number(item.committeeApprovalStatus) === 4
    );

  const managementApprovedCount =
    props.managementCommitteeApproval?.filter(
      m => Number(m.committeeApprovalStatus) === 5
    ).length || 0;




  const handleChangeInPriceTable = (value, name, year, tableName) => {
    props.handleChangeInPriceTable(value, name, year, tableName);
  };
  const isAnyApprovedSeconder = props.membershipCommitteeApproval.some(
    (item) => {
      const approvalStatus = props.committeeApprovalStatusList.find(
        (type) => type.id === item.committeeApprovalStatus
      );
      return approvalStatus?.name === "Approved-Seconder";
    }
  );
  const approvedCount = props.managementCommitteeApproval.reduce(
    (count, item) => {
      const approvalStatus = props.committeeApprovalStatusList.find(
        (type) => type.id === item.committeeApprovalStatus
      );
      return approvalStatus?.name === "Approved" ? count + 1 : count;
    },
    0
  );
  const { selfDeclarationComment } = props;

  const isTwelveOrMoreApproved = approvedCount >= 12;

  // const [endorserBothValid, setEndorserBothValid] = useState(false);
  // useEffect(() => {
  //   if (props.taskDetails.endorsementSatusForEndorser1 && props.taskDetails.endorsementSatusForEndorser2 === 'Approved'
  //   ) {
  //     setEndorserBothValid(true);
  //   } else {
  //     setEndorserBothValid(false);
  //   }
  // }, [props.taskDetails.endorsementSatusForEndorser1, props.taskDetails.endorsementSatusForEndorser2]);
  return (
    <ModalBasic
      id="add-edit-modal"
      className="membership-add-edit-modal"
      modalOpen={props.setAddeditModalOpen}
      setModalOpen={props.setModalOpen}
      title="Membership Task List Process"
    >
      {/* Modal content */}
      <div
        className={`2xl:px-14 lg:px-3 pt-4 ${ props.statusId === 10 || props.statusId === 2 ? "opacity-50 pointer-events-none" : ""}`}
      >
        <div className="">
          <div className="relative">
            <SectionWithBorder title="Account Information">
              <div className="">
                <div className="grid grid-cols-12 gap-6 w-full items-center pt-7 pb-0">
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          {" "}
                          Membership Type{" "}
                          <span className="text-[#C00000]">*</span>
                        </label>
                        <DropdownSelect
                          drpIdentity={"MembershipType"}
                          optionArray={props.membershipType}
                          setFilterParameters={props.setFilterParameters}
                          value={
                            props.taskDetails.membershipTypeId
                              ? props.taskDetails.membershipTypeId
                              : 1
                          }
                          disabled={props.statusId === 10}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Transaction Type{" "}
                          <span className="text-[#C00000]"> *</span>
                        </label>
                        <DropdownSelect
                          drpIdentity={"TransactionTypes"}
                          optionArray={props.transactionTypes}
                          setFilterParameters={props.setFilterParameters}
                          value={
                            props.taskDetails.transactionTypeId
                              ? props.taskDetails.transactionTypeId
                              : 1
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Subscription Start Date
                          <span className="text-[#C00000]"> *</span>
                        </label>

                        <input
                          id="default"
                          className="date-pickers form-input rounded-none w-full py-3 text-lg bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                          type="date"
                          name="subscriptionStartDate"
                          max={moment(new Date()).format("yyyy-MM-DD")}
                          value={
                            props.taskDetails.subscriptionStartDate
                              ? moment(
                                props.taskDetails.subscriptionStartDate
                              ).format("yyyy-MM-DD")
                              : props.taskDetails.subscriptionStartDate
                          }
                          onChange={(event) => props.handleChange(event)}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                  {props.taskDetails.transactionTypeId === 3 ? (
                    <div className="xl:col-span-6 md:col-span-6 col-span-12">
                      <div className="grid grid-cols-12 gap-6">
                        <div className="xl:col-span-12 md:col-span-12 col-span-12">
                          <label
                            className="date-pickers form-input rounded-none w-full py-3 text-lg bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                            htmlFor="default"
                          >
                            Subscription End Date
                            {/* <span className="text-[#C00000]"> *</span> */}
                          </label>
                          <div className="grid grid-cols-12 gap-6 items-center w-full">
                            <div className=" 2xl:col-span-12 lg:col-span-12 col-span-12 w-full ">
                              <input
                                id="default"
                                name="subscriptionEndDate"
                                className="date-pickers form-input rounded-none w-full py-3 text-lg bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                type="date"
                                value={
                                  props.taskDetails?.subscriptionEndDate
                                    ? moment(
                                      props.taskDetails.subscriptionEndDate
                                    ).format("YYYY-MM-DD")
                                    : ""
                                }
                                onChange={(event) => props.handleChange(event)}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="xl:col-span-6 md:col-span-6 col-span-12">
                      <div className="grid grid-cols-12 gap-6">
                        <div className="xl:col-span-12 md:col-span-12 col-span-12">
                          <label
                            className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                            htmlFor="default"
                          >
                            Subscription End Date
                            {/* <span className="text-[#C00000]"> *</span> */}
                          </label>
                          <div className="grid grid-cols-12 gap-6 items-center w-full">
                            <div className=" 2xl:col-span-12 lg:col-span-12 col-span-12 w-full ">
                              <input
                                id="default"
                                name="subscriptionEndDate"
                                className="date-pickers form-input rounded-none w-full py-3 text-lg bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                                type="date"
                                max={`${new Date().getFullYear()}-12-31`}
                                value={
                                  props.taskDetails.subscriptionEndDate
                                    ? moment(
                                      props.taskDetails.subscriptionEndDate
                                    ).format("YYYY-MM-DD")
                                    : ""
                                }
                                onChange={(event) => props.handleChange(event)}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable flex w-full font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Last Updated Date
                          {/* <span className="text-[#C00000]"> *</span> */}
                        </label>
                        <div className="grid grid-cols-12 gap-6 items-center w-full">
                          <div className=" 2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            <input
                              id="default"
                              name="lastUpdatedDate"
                              className="date-pickers form-input rounded-none w-full py-3 text-lg bg-gray-200 text-gray-500 cursor-not-allowed opacity-70"
                              type="date"
                              value={
                                props.taskDetails.lastUpdatedDate
                                  ? moment(
                                    props.taskDetails.lastUpdatedDate
                                  ).format("yyyy-MM-DD")
                                  : `${new Date().getFullYear()}-12-31`
                              }
                              disabled={true}
                              onChange={(event) => props.handleChange(event)}
                            // onBlur={() => props.validateField("publishDate")}
                            />
                            {/* <div>
                          <ValidationText error={props.validState.error.publishDate} />
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12 flex flex-col items-end">
                        <label
                          className="filter-lable flex w-full font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        ></label>
                        {props.isLoadingReject ? (
                          <div className="py-2 w-[350px] btn btn-red text-lg text-white font-bold">
                            <ButtonLoader className="buttonload group relative btn btn-red text-xl text-white focus:outline-none" />
                          </div>
                        ) : (
                          <button
                            className={`py-2 w-[350px] btn btn-red text-lg text-white font-bold`}
                            onClick={() =>
                              props.updateCorporateMemberUpdate(
                                props.taskDetails.corporateMemberId
                              )
                            }
                          >
                            View Corporate Information
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SectionWithBorder>

            <button
              className="absolute top-4 right-4 bg-blue-500 font-semibold text-white py-2 px-4 rounded"
              onClick={() =>
                props.getAllDetailsForGeneratePDF(
                  props.taskDetails.corporateMemberId
                )
              }
            >
              Download PDF
            </button>
          </div>
          <SectionWithBorder title="Application Information">
            <div className="grid grid-cols-12 gap-6  w-full items-center pt-7">
              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Company Name <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                      type="text"
                      name="companyName"
                      value={props.taskDetails.companyName}
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}

                    // validateField={() => props.validateField("organisationName")}
                    />
                    {/* <ValidationText error={props.validState.error.organisationName} /> */}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Company UEN <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                      type="text"
                      name="companyUEN"
                      value={props.taskDetails.companyUEN}
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}

                    // validateField={() => props.validateField("organisationUEN")}
                    />
                    <div>
                      {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Total Group Asset{" "}
                      {props.taskDetails.membershipTypeId === 1 && (
                        <span className="text-[#C00000]">*</span>
                      )}
                    </label>
                    <DropdownSelect
                      drpIdentity={"totalGroupAssets"}
                      optionArray={props.totalGroupAssets}
                      setFilterParameters={props.setFilterParameters}
                      value={
                        props.taskDetails.groupAssetId
                          ? props.taskDetails.groupAssetId
                          : 0
                      }
                      disabled={props.statusId === 10}

                    />
                  </div>
                  {/* <ValidationText error={props.validState.error.paidUpCapital} /> */}
                </div>
              </div>
              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Incorporation Date{" "}
                      <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      name="incorporationDate"
                      max={moment(new Date()).format("yyyy-MM-DD")}
                      value={
                        props.taskDetails.incorporationDate
                          ? moment(props.taskDetails.incorporationDate).format(
                            "yyyy-MM-DD"
                          )
                          : ""
                      }
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}

                    // onBlur={() => props.validateField("incorporationDate")}
                    />
                    <div>
                      {/* <ValidationText error={props.validState.error.incorporationDate} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SectionWithBorder>
          {props.boardDirectorList != null ? (
            <SectionWithBorder title="Board of Directors">
              <div className="grid grid-cols-12 gap-4 w-full items-center pt-7 px-7 pb-7">
                <div className="col-span-12">
                  <div className="overflow-x-auto pb-5">
                    <table className="border border-[#d0d0d0] w-full  ">
                      <BoardOfDirectors
                        boardAndTopMtgList={props.boardAndTopMtgList}
                        boardDirectorList={props.boardDirectorList}
                      />
                    </table>
                  </div>
                </div>
              </div>
            </SectionWithBorder>
          ) : null}
          {props.topManagementList != null ? (
            <SectionWithBorder title="Top Management">
              <div className="grid grid-cols-12 gap-4 w-full items-center pt-7 px-7 pb-7">
                <div className="col-span-12">
                  <div className="overflow-x-auto pb-5">
                    <table className="border border-[#d0d0d0] w-full  ">
                      <BoardOfDirectors
                        boardAndTopMtgList={props.boardAndTopMtgList}
                        topManagementList={props.topManagementList}
                      />
                    </table>
                  </div>
                </div>
              </div>
            </SectionWithBorder>
          ) : null}
          {props.taskDetails.membershipTypeId === 1 ? (
            <>
              <SectionWithBorder title="Ordinary - Projects Completed">
                <div className="grid grid-cols-12 gap-4 w-full items-center pt-7 px-7 pb-7">
                  <div className="col-span-12">
                    <div className="overflow-x-auto pb-5">
                      <table className="border border-[#d0d0d0] w-full  ">
                        <OrdinaryProjectsCompleted
                          ordinaryProjectsCompletedList={
                            props.ordinaryProjectsCompletedList
                          }
                          // ordinaryProjectsInCompleteList={props.ordinaryProjectsInCompleteList}
                          ordinaryMainProjectList={
                            props.ordinaryMainProjectList
                          }
                        />
                      </table>
                    </div>
                  </div>
                </div>
              </SectionWithBorder>

              <SectionWithBorder title="Ordinary - Projects In Progress/Pipeline">
                <div className="grid grid-cols-12 gap-4 w-full items-center pt-7 px-7 pb-7">
                  <div className="col-span-12">
                    <div className="overflow-x-auto pb-5">
                      <table className="border border-[#d0d0d0] w-full  ">
                        <OrdinaryProjectsCompleted
                          ordinaryProjectsInCompleteList={
                            props.ordinaryProjectsInCompleteList
                          }
                          // ordinaryProjectsCompletedList={props.ordinaryProjectsCompletedList}
                          ordinaryMainProjectList={
                            props.ordinaryMainProjectList
                          }
                        />
                      </table>
                    </div>
                  </div>
                </div>
              </SectionWithBorder>
            </>
          ) : null}

          <SectionWithBorder title="Representative in REDAS">
            <div className="">
              <div className="grid grid-cols-12 gap-6  w-full items-center pt-7">
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        First Name <span className="text-[#C00000]">*</span>
                      </label>
                      <div className="flex">
                        <div className="w-[130px] ">
                          <DropdownSelect
                            drpIdentity={"Salutation1"}
                            optionArray={props.mrMrs}
                            setFilterParameters={props.setFilterParameters}
                            value={
                              props.representativeDetails?.[ 0 ]?.salutation ?? 0
                            }
                            disabled={props.statusId === 10}

                          />
                        </div>
                        <input
                          id="default"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                          type="text"
                          name="firstName"
                          value={
                            props.representativeDetails?.[ 0 ]?.firstName ?? ""
                          }
                          onChange={(event) => props.handleChange(event, "rep")}
                          disabled={props.statusId === 10}

                        />
                      </div>
                      {/* <ValidationText error={props.validState.error.organisationName} /> */}
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        Last Name <span className="text-[#C00000]">*</span>
                      </label>
                      <input
                        id="default"
                        className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                        type="text"
                        name="lastName"
                        value={props.representativeDetails[ 0 ]?.lastName || ""}
                        onChange={(event) => props.handleChange(event, "rep")}
                        disabled={props.statusId === 10}

                      // validateField={() => props.validateField("organisationUEN")}
                      />
                      <div>
                        {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        Designation <span className="text-[#C00000]">*</span>
                      </label>
                      <input
                        id="default"
                        className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                        type="text"
                        name="designation"
                        value={
                          props.representativeDetails?.[ 0 ]?.designation ?? ""
                        }
                        onChange={(event) => props.handleChange(event, "rep")}
                        disabled={props.statusId === 10}

                      // validateField={() => props.validateField("organisationName")}
                      />
                      {/* <ValidationText error={props.validState.error.organisationName} /> */}
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        Job Position <span className="text-[#C00000]"> *</span>
                      </label>
                      <DropdownSelect
                        drpIdentity={"JobPosition1"}
                        optionArray={props.jobPosition}
                        setFilterParameters={props.setFilterParameters}
                        value={
                          props.representativeDetails?.[ 0 ]?.jobPosition ?? ""
                        }
                        disabled={props.statusId === 10}

                      />
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        Business Email<span className="text-[#C00000]">*</span>
                      </label>
                      <input
                        id="default"
                        className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                        type="text"
                        name="bussinessEmail"
                        value={
                          props.representativeDetails[ 0 ]?.bussinessEmail || ""
                        }
                        onChange={(event) => props.handleChange(event, "rep")}
                        disabled={props.statusId === 10}

                      // validateField={() => props.validateField("organisationName")}
                      />
                      {/* <ValidationText error={props.validState.error.organisationName} /> */}
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        Business Number
                        <span className="text-[#C00000]">*</span>
                      </label>
                      <div className="flex">
                        <div className="w-[130px]">
                          <DropdownSelect
                            drpIdentity={"CountriesDailingCode1"}
                            optionArray={props.countriesDailing}
                            setFilterParameters={props.setFilterParameters}
                            value={
                              props.representativeDetails?.[ 0 ]
                                ?.countryDialingCodeID ?? ""
                            }
                            disabled={props.statusId === 10}

                          />
                        </div>
                        <input
                          id="default"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                          type="text"
                          name="bussinessContactNo"
                          value={
                            props.representativeDetails?.[ 0 ]
                              ?.bussinessContactNo ?? ""
                          }
                          onChange={(event) => props.handleChange(event, "rep")}
                          disabled={props.statusId === 10}

                        // validateField={() => props.validateField("organisationUEN")}
                        />
                      </div>
                      <div>
                        {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="xl:col-span-12 md:col-span-12 col-span-12">
                      <label
                        className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                        htmlFor="default"
                      >
                        Comments
                      </label>
                      <textarea
                        id="default"
                        className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                        type="text"
                        name="comments"
                        value={props.representativeDetails?.[ 0 ]?.comments ?? ""}
                        onChange={(event) => props.handleChange(event, "rep")}
                        disabled={props.statusId === 10}

                      />
                      {/* <ValidationText error={props.validState.error.organisationName} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SectionWithBorder>
          {props.alternativeRepresentative?.length > 0 ? (
            <SectionWithBorder title="Alternative Representative in REDAS">
              <div className="">
                <div className="grid grid-cols-12 gap-6  w-full items-center pt-7">
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          First Name <span className="text-[#C00000]">*</span>
                        </label>
                        <div className="flex">
                          <div className="w-[130px]">
                            <DropdownSelect
                              drpIdentity={"Salutation2"}
                              optionArray={props.mrMrs}
                              setFilterParameters={props.setFilterParameters}
                              value={
                                props.alternativeRepresentative?.[ 0 ]
                                  ?.salutation ?? 0
                              }
                              disabled={props.statusId === 10}

                            />
                          </div>
                          <input
                            id="default"
                            className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                            type="text"
                            name="firstName"
                            value={
                              props.alternativeRepresentative?.[ 0 ]?.firstName ??
                              ""
                            }
                            onChange={(event) =>
                              props.handleChange(event, "alterRep")
                            }
                            disabled={props.statusId === 10}

                          // validateField={() => props.validateField("organisationUEN")}
                          />
                        </div>
                        {/* <ValidationText error={props.validState.error.organisationName} /> */}
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Last Name <span className="text-[#C00000]">*</span>
                        </label>
                        <input
                          id="default"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                          type="text"
                          name="lastName"
                          value={
                            props.alternativeRepresentative?.[ 0 ]?.lastName ?? ""
                          }
                          onChange={(event) =>
                            props.handleChange(event, "alterRep")
                          }
                          disabled={props.statusId === 10}

                        // validateField={() => props.validateField("organisationUEN")}
                        />
                        <div>
                          {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Designation <span className="text-[#C00000]">*</span>
                        </label>
                        <input
                          id="default"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                          type="text"
                          name="designation"
                          value={
                            props.alternativeRepresentative?.[ 0 ]?.designation ??
                            ""
                          }
                          onChange={(event) =>
                            props.handleChange(event, "alterRep")
                          }
                          disabled={props.statusId === 10}

                        // validateField={() => props.validateField("organisationName")}
                        />
                        {/* <ValidationText error={props.validState.error.organisationName} /> */}
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Job Position{" "}
                          <span className="text-[#C00000]"> *</span>
                        </label>
                        <DropdownSelect
                          drpIdentity={"JobPosition2"}
                          optionArray={props.jobPosition}
                          setFilterParameters={props.setFilterParameters}
                          value={
                            props.alternativeRepresentative?.[ 0 ]?.jobPosition ??
                            0
                          }
                          disabled={props.statusId === 10}

                        />
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Business Email
                          <span className="text-[#C00000]">*</span>
                        </label>
                        <input
                          id="default"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                          type="text"
                          name="bussinessEmail"
                          value={
                            props.alternativeRepresentative?.[ 0 ]
                              ?.bussinessEmail ?? ""
                          }
                          onChange={(event) =>
                            props.handleChange(event, "alterRep")
                          }
                          disabled={props.statusId === 10}

                        // validateField={() => props.validateField("organisationName")}
                        />
                        {/* <ValidationText error={props.validState.error.organisationName} /> */}
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Business Number
                          <span className="text-[#C00000]">*</span>
                        </label>
                        <div className="flex">
                          <div className="w-[130px]">
                            <DropdownSelect
                              drpIdentity={"CountriesDailingCode2"}
                              optionArray={props.countriesDailing}
                              setFilterParameters={props.setFilterParameters}
                              value={
                                props.alternativeRepresentative?.[ 0 ]
                                  ?.countryDialingCodeID ?? 0
                              }
                              disabled={props.statusId === 10}

                            />
                          </div>
                          <input
                            id="default"
                            className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                            type="text"
                            name="bussinessContactNo"
                            value={
                              props.alternativeRepresentative?.[ 0 ]
                                ?.bussinessContactNo ?? ""
                            }
                            onChange={(event) =>
                              props.handleChange(event, "alterRep")
                            }
                            disabled={props.statusId === 10}

                          // validateField={() => props.validateField("organisationUEN")}
                          />
                        </div>
                        <div>
                          {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xl:col-span-6 md:col-span-6 col-span-12">
                    <div className="grid grid-cols-12 gap-6">
                      <div className="xl:col-span-12 md:col-span-12 col-span-12">
                        <label
                          className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                          htmlFor="default"
                        >
                          Comments
                        </label>

                        <textarea
                          id="default"
                          className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                          type="text"
                          name="comments"
                          value={
                            props.alternativeRepresentative?.[ 0 ]?.comments ?? ""
                          }
                          onChange={(event) =>
                            props.handleChange(event, "alterRep")
                          }
                          disabled={props.statusId === 10}

                        // validateField={() => props.validateField("organisationName")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SectionWithBorder>
          ) : null}

          <SectionWithBorder title="Self Declaration" >
            <div className="question" style={{ marginTop: "15px" }}>
              <label className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30" htmlFor="default"
              >Has the Applicant, or any of its directors/principal officers, ever been, or is currently, listed on any monitoring list maintained by the

                Monetary Authority of Singapore (MAS) or any other relevant regulatory authority in relation to anti-money laundering, counter-terrorism

                financing, or related compliance matters? <span className="required-star">*</span>
              </label>

              <div className="options" style={{ display: "flex", alignItems: "center", marginTop: "10px", gap: "20px", cursor: "not-allowed" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <input
                    style={{ cursor: "not-allowed" }}
                    type="radio"
                    name="selfDeclarationComment"
                    value="Yes"
                    checked={props.selfDeclarationComment === "Yes"}
                    onChange={() => props.handleRadioClick("Yes", props.taskDetails.selfDeclaration)}
                    disabled
                  />
                  Yes
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <input
                    style={{ cursor: "not-allowed" }}
                    type="radio"
                    name="selfDeclarationComment"
                    value="No"
                    checked={props.selfDeclarationComment === "No"}
                    onChange={() => props.handleRadioClick("No", "")}
                    disabled
                  />
                  No
                </label>
              </div>


              {props.selfDeclarationComment === "Yes" && (
                <div
                  className="details"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginTop: "15px",
                    gap: "10px",
                    cursor: "not-allowed"
                  }}
                >
                  <label
                    className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                    htmlFor="default"
                  >  If Yes, please provide details:</label>
                  <textarea

                    rows="3"
                    className="details-textarea"
                    placeholder="Enter details here..."
                    value={props.taskDetails.selfDeclaration}
                    onChange={(e) => this.setState({ selfDeclaration: e.target.value })}
                    style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc", cursor: "not-allowed" }}
                    disabled
                  ></textarea>
                </div>
              )}


            </div>
          </SectionWithBorder>
          <SectionWithBorder
            title="Membership Committee Review"
            className="list-card"
          >
            <form className="mt-10 mb-10 membership-form">
              <div className="field flex gap-2">
                <label>Secretariat Comments</label>
                {/* <input
                  id="EntryName"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575] disabled:bg-gray-200 disabled:cursor-not-allowed"
                  type="text"
                  name="comments"
                  value={props.membershipCommitteeApprovalDetails.comments}
                  onChange={(event) => props.handleChangeForApproval(event, "comments1")}
                  disabled={props.membershipCommitteeInfoAvailable === true}
                /> */}
                <div className="input-width-velidation">
                  <textarea
                    id="EntryName"
                    name="comments"
                    rows={4}
                    className="w-full form-input common-textarea rounded-none w-full shadow-red py-3 text-lg text-[#757575] disabled:bg-gray-200 disabled:cursor-not-allowed"
                    value={props.membershipCommitteeApprovalDetails.comments}
                    onChange={(event) =>
                      props.handleChangeForApproval(event, "comments1")
                    }
                    disabled={props.membershipCommitteeInfoAvailable === true || props.statusId === 10}
                    // validateField={() => props.validateField("comments", "Committee")}
                    //onBlur={() => props.validateField("comments")}
                    onBlur={() => props.validateFieldForMembership("comments")}

                  />
                  <ValidationText error={props.validState.error.comments} />
                </div>
              </div>
              <div className="field flex gap-2">
                <label>Deadline</label>
                <div className="input-width-velidation">
                  <input
                    id="startDate3"
                    className="w-full date-pickers form-input rounded-none w-full shadow-red py-3 text-lg disabled:bg-gray-200 disabled:cursor-not-allowed"
                    type="date"
                    name="deadLineDate"
                    value={moment(
                      props.membershipCommitteeApprovalDetails.deadLineDate
                    ).format("yyyy-MM-DD")}
                    onChange={(event) =>
                      props.handleChangeForApproval(event, "datePicker1")
                    }
                    min={moment().format("YYYY-MM-DD")}
                    disabled={props.membershipCommitteeInfoAvailable === true || props.statusId === 10}
                    // validateField={() => props.validateField("deadLineDate", "Committee")}
                    onBlur={() => props.validateFieldForMembership("deadLineDate")}
                  />
                  <ValidationText error={props.validState.error.deadLineDate} />
                </div>
              </div>
              <div className="flex">
                {props.isMembershipSendApprovalLoading ? (
                  <ButtonLoader className="btn-loader btn ml-auto" />
                ) : (
                  <button
                    className="btn btn-outline ml-auto disabled:bg-gray-200 disabled:cursor-not-allowed"
                    onClick={(e) =>
                      props.committeeApproval(e, {
                        ...props.membershipCommitteeApprovalDetails,
                      })
                    }
                    disabled={props.membershipCommitteeInfoAvailable || props.statusId === 10}
                  >
                    Send for Approval
                  </button>
                )}
              </div>
            </form>

            <table className="table-auto theme-table w-full">
              <thead className="bg-[#f2f2f2]  border-[#757575]  text-[#757575] ">
                <tr>
                  <th className="border px-4 py-2">Name</th>
                  <th className="border px-4 py-2">Status</th>
                  <th className="border px-4 py-2">Submission Type</th>
                  <th className="border px-4 py-2">Comments</th>
                  <th className="border px-4 py-2">Decision Date</th>
                  <th className="border px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {props.membershipCommitteeApproval &&
                  props.membershipCommitteeApproval.map((item, index) => {
                    const approvalStatus =
                      props.committeeApprovalStatusList.find(
                        (type) => type.id === item.committeeApprovalStatus
                      );

                    const isApprovedProposer =
                      approvalStatus?.name === "Approved-Proposer";
                    const isButtonDisabled =
                      !!props.taskDetails.isMembershipCommitteeApprovalSubmitted;

                    return (
                      <tr key={index}>
                        <td className="border px-4 py-2 text-center">
                          {item.committeeMemberName || "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {approvalStatus?.name || "N/A"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {props.submissionTypeList?.find(type => type.id === item.submissionTypeId)?.name || "-"}

                        </td>
                        <td className="border px-4 py-2 text-center">
                          {item.committeeApprovalComments || "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {item.decisionDate
                            ? moment(item.decisionDate).format("MM/DD/YYYY")
                            : "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <button
                            onClick={() => props.resendCommitteeApproval(item)}
                            className={`text-blue-500 hover:underline focus:outline-none ${isButtonDisabled
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                              }`}
                            disabled={isButtonDisabled || props.statusId === 10}
                          >
                            Resend
                          </button>
                        </td>
                        {/* <td className="border px-4 py-2 text-center">{item.endorserComment || "-"}</td> */}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <form className="mt-10 mb-10 membership-form">
              <div className="field flex gap-2">
                <label>Additional Notes</label>
                <textarea
                  id="additionalNotes"
                  className="form-input common-textarea rounded-none w-full shadow-red py-3 text-lg text-[#757575] disabled:bg-gray-200 disabled:cursor-not-allowed"
                  rows={4}
                  name="additionalNotes"
                  value={
                    props.membershipAdditionalInformationDetails.additionalNotes
                  }
                  onChange={(event) =>
                    props.handleChangeForApproval(event, "additionalNotes1")
                  }
                  disabled={props.isMembershipCommitteeadditionalInfo === true}
                />
              </div>
              <div className="field flex gap-2">
                <label>Membership Committee Review Date </label>
                <input
                  id="additionalDate"
                  className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg disabled:bg-gray-200 disabled:cursor-not-allowed"
                  type="date"
                  name="additionalDate"
                  value={moment(
                    props.membershipAdditionalInformationDetails.additionalDate
                  ).format("yyyy-MM-DD")}
                  onChange={(event) =>
                    props.handleChangeForApproval(event, "additionalDate1")
                  }
                  min={moment().format("YYYY-MM-DD")}
                  disabled={props.isMembershipCommitteeadditionalInfo === true}
                />
              </div>
              <div className="flex">
                {props.isMembershipSubmitLoading === true ? (
                  <ButtonLoader className="btn-loader btn ml-auto" />
                ) : (
                  <button
                    className="btn btn-outline ml-auto disabled:bg-gray-200 disabled:cursor-not-allowed"
                    onClick={(e) =>
                      props.additionalInfomationSubmit(e, {
                        ...props.membershipAdditionalInformationDetails,
                      })
                    }
                    disabled={
                      props.isMembershipCommitteeadditionalInfo === true || hasStatusFour === false
                    }
                  >
                    Submit
                  </button>
                )}
              </div>
            </form>
          </SectionWithBorder>
          <SectionWithBorder
            title=" Management Committee Approval"
            className="list-card"
          >
            <form className="mt-10 mb-10 membership-form">
              <div className="field flex gap-2">
                <label>Secretariat Comments</label>
                <div className="input-width-velidation">
                  <textarea
                    id="EntryName"
                    className="w-full form-input common-textarea rounded-none w-full shadow-red py-3 text-lg text-[#757575] disabled:bg-gray-200 disabled:cursor-not-allowed"
                    rows={4}
                    name="comments"
                    value={props.managementCommitteeApprovalDetails.comments}
                    onChange={(event) =>
                      props.handleChangeForApproval(event, "comments2")
                    }
                    disabled={props.managementCommitteeInfoAvailable === true}
                    onBlur={() => props.validateFieldForManagement("comments")}
                  />
                  <ValidationText error={props.validStateForManagement.error.comments} />
                </div>
              </div>
              <div className="field flex gap-2">
                <label>Deadline </label>
                <div className="input-width-velidation">
                  <input
                    id="startDate3"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg disabled:bg-gray-200 disabled:cursor-not-allowed"
                    type="date"
                    name="deadLineDate"
                    value={moment(
                      props.managementCommitteeApprovalDetails.deadLineDate
                    ).format("yyyy-MM-DD")}
                    onChange={(event) =>
                      props.handleChangeForApproval(event, "datePicker2")
                    }
                    min={moment().format("YYYY-MM-DD")}
                    disabled={props.managementCommitteeInfoAvailable === true}
                    onBlur={() => props.validateFieldForManagement("deadLineDate")}

                  // validateField={() => props.validateField("deadLineDate", "Committee")}
                  //onBlur={() => props.validateField("deadLineDate")}

                  />
                  <ValidationText
                    error={props.validStateForManagement.error.deadLineDate}
                  />
                </div>
              </div>
              <div className="flex">
                {props.isManagementSendApprovalLoading ? (
                  <ButtonLoader className="btn-loader btn ml-auto" />
                ) : (
                  <button
                    className="btn btn-outline ml-auto bg-white disabled:bg-gray-200 disabled:cursor-not-allowed"
                    disabled={
                      props.isMCApprovalSubmitted === null ||
                      !props.isMCApprovalSubmitted ||
                      props.managementCommitteeInfoAvailable
                    }
                    onClick={(e) =>
                      props.committeeApproval(e, {
                        ...props.managementCommitteeApprovalDetails,
                      })
                    }
                  >
                    Send for Approval
                  </button>
                )}
              </div>
            </form>
            <table className="table-auto theme-table w-full">
              <thead className="bg-[#f2f2f2]  border-[#757575]  text-[#757575] ">
                <tr>
                  <th className="border px-4 py-2">Name</th>
                  <th className="border px-4 py-2">Status</th>
                  <th className="border px-4 py-2">Submission Type</th>
                  <th className="border px-4 py-2">Comments</th>
                  <th className="border px-4 py-2">Decision Date</th>
                  <th className="border px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {props.managementCommitteeApproval &&
                  props.managementCommitteeApproval.map((item, index) => {
                    const managementapprovalStatus =
                      props.committeeApprovalStatusList.find(
                        (type) => type.id === item.committeeApprovalStatus
                      );

                    const isApprovedManagementProposer =
                      managementapprovalStatus?.name === "Approved";
                    const isManagementButtonDisabled =
                      !!props.taskDetails.isManagementCommitteeApprovalSubmitted;

                    return (
                      <tr key={index}>
                        <td className="border px-4 py-2 text-center">
                          {item.committeeMemberName
                            ? item.committeeMemberName
                            : "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {props.committeeApprovalStatusList.find(
                            (type) => type.id === item.committeeApprovalStatus
                          )?.name || "N/A"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {props.submissionTypeList?.find(type => type.id === item.submissionTypeId)?.name || "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {item.committeeApprovalComments
                            ? item.committeeApprovalComments
                            : "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          {item.decisionDate
                            ? moment(item.decisionDate).format("MM/DD/YYYY")
                            : "-"}
                        </td>
                        <td className="border px-4 py-2 text-center">
                          <button
                            onClick={() => props.resendCommitteeApproval(item)}
                            disabled={isManagementButtonDisabled}
                            className={`text-blue-500 hover:underline focus:outline-none ${isManagementButtonDisabled
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                              }`}
                          >
                            Resend
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <form className="mt-10 mb-10 membership-form">
              <div className="field flex gap-2">
                <label>Additional Notes</label>
                <textarea
                  id="additionalNotes"
                  className="form-input common-textarea rounded-none w-full shadow-red py-3 text-lg text-[#757575] disabled:bg-gray-200 disabled:cursor-not-allowed"
                  rows={4}
                  name="additionalNotes"
                  value={
                    props.managementAdditionalInformationDetails.additionalNotes
                  }
                  onChange={(event) =>
                    props.handleChangeForApproval(event, "additionalNotes2")
                  }
                  disabled={props.isManagementCommitteeadditionalInfo === true || props.statusId === 10}
                />
              </div>
              <div className="field flex gap-2">
                <label>Management Committee Approval Date </label>
                <input
                  id="additionalDate"
                  className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg disabled:bg-gray-200 disabled:cursor-not-allowed"
                  type="date"
                  name="additionalDate"
                  value={moment(
                    props.managementAdditionalInformationDetails.additionalDate
                  ).format("yyyy-MM-DD")}
                  onChange={(event) =>
                    props.handleChangeForApproval(event, "additionalDate2")
                  }
                  min={moment().format("YYYY-MM-DD")}
                  disabled={props.isManagementCommitteeadditionalInfo === true || props.statusId === 10}
                />
              </div>
              <div className="flex">
                {props.isManagementSubmitLoading === true ? (
                  <ButtonLoader className="btn-loader btn ml-auto" />
                ) : (
                  <button
                    className="btn btn-outline ml-auto bg-white disabled:bg-gray-200 disabled:cursor-not-allowed"
                    disabled={
                      props.isMCApprovalSubmitted === null ||
                      !props.isMCApprovalSubmitted ||
                      props.isManagementCommitteeadditionalInfo === true || props.statusId === 10
                    }
                    onClick={(e) =>
                      props.additionalInfomationSubmit(e, {
                        ...props.managementAdditionalInformationDetails,
                      })
                    }
                  >
                    Submit
                  </button>
                )}
              </div>
            </form>
          </SectionWithBorder>
          {/* <div className="flex items-baseline register-desc mb-5">
            <input
              id="isCOForBiilingChecked"
              name="isCOForBiilingChecked"
              type="checkbox"
              className="cursor-pointer h-4 w-4 text-[#C00000] focus:ring-[#C00000] rounded check-box-custom"
              onChange={(event) => props.handleChangeCheckBox(event)}
              checked={
                props.taskDetails.isCOForBiilingChecked
              }
              value={props.taskDetails.isCOForBiilingChecked}
            />
            <label className="communication-label ml-3 block text-[#757575] 2xl:text-[22px]">
              C/O for Billing
            </label>
          </div> */}

          {/* {props.taskDetails.isCOForBiilingChecked && ( */}

          <SectionWithBorder title="C/O for Billing" className="list-card">
            <div className="grid grid-cols-12 gap-6  w-full items-center pt-7">
              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Billing Entity <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                      type="text"
                      name="billingEntity"
                      value={props.taskDetails.billingEntity ?? ""}
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}

                    // validateField={() => props.validateField("organisationUEN")}
                    />
                    <div>
                      {/* <ValidationText error={props.validState.error.organisationUEN} /> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Billing Attention{" "}
                      <span className="text-[#C00000]">*</span>
                    </label>
                    <div className="flex">
                      <div className="w-[130px]">
                        <DropdownSelect
                          drpIdentity={"AttentionSalutation"}
                          optionArray={props.mrMrs}
                          setFilterParameters={props.setFilterParameters}
                          value={props.taskDetails.attentionSalutationId ?? 0}
                          disabled={props.statusId === 10}

                        />
                      </div>
                      <input
                        id="default"
                        className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                        type="text"
                        name="billingAttention"
                        value={props.taskDetails.billingAttention ?? ""}
                        onChange={(event) => props.handleChange(event)}
                        disabled={props.statusId === 10}

                      // validateField={() => props.validateField("organisationUEN")}
                      />
                    </div>
                    {/* <ValidationText error={props.validState.error.organisationName} /> */}
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Billing Email Address{" "}
                      <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                      type="text"
                      name="billingEmailAddress"
                      value={props.taskDetails.billingEmailAddress ?? ""}
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}

                    // validateField={() => props.validateField("organisationName")}
                    />
                    {/* <ValidationText error={props.validState.error.organisationName} /> */}
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Billing Country <span className="text-[#C00000]">*</span>
                    </label>
                    <DropdownSelect
                      drpIdentity={"CountriesForCO"}
                      optionArray={props.CountriesForCO}
                      setFilterParameters={props.setFilterParameters}
                      value={props.taskDetails.billingCountryId ?? ""}
                      disabled={props.statusId === 10}

                    // onBlur={(e) => props.validate("updatedById", props.membershipSubscription)}
                    />
                    {/* <Validation error={props.validState.error.updatedById} /> */}
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Billing Address <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                      type="text"
                      name="billingAddress"
                      value={props.taskDetails.billingAddress ?? ""}
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}


                    // validateField={() => props.validateField("organisationName")}
                    />
                    {/* <ValidationText error={props.validState.error.organisationName} /> */}
                  </div>
                </div>
              </div>

              <div className="xl:col-span-6 md:col-span-6 col-span-12">
                <div className="grid grid-cols-12 gap-6">
                  <div className="xl:col-span-12 md:col-span-12 col-span-12">
                    <label
                      className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                      htmlFor="default"
                    >
                      Billing Postal Code{" "}
                      <span className="text-[#C00000]">*</span>
                    </label>
                    <input
                      id="default"
                      className="form-input rounded-none w-full shadow-red py-3 text-lg text-[#757575]"
                      type="text"
                      name="billingPostalCode"
                      value={props.taskDetails.billingPostalCode ?? ""}
                      onChange={(event) => props.handleChange(event)}
                      disabled={props.statusId === 10}

                    // validateField={() => props.validateField("organisationName")}
                    />
                    {/* <ValidationText error={props.validState.error.organisationName} /> */}
                  </div>
                </div>
              </div>
            </div>
          </SectionWithBorder>


          {/* )} */}

          {/* <SectionWithBorder title="Council Approval">
            <div className="">
              <div className="grid grid-cols-12 gap-6 w-full items-center pt-3 pb-7 mt-5">
                <div className="xl:col-span-6 md:col-span-6 col-span-12">
                  <label
                    className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                    htmlFor="default"
                  >
                    Approval Date <span className="text-[#C00000]">*</span> */}
          {/* </label> */}
          {/* <input 
                    id="default"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    name="approvalDate"
                  max={moment(new Date()).format("yyyy-MM-DD")}
                  value={props.taskDetails.approvalDate ? moment(props.taskDetails.approvalDate).format("yyyy-MM-DD") : moment(new Date()).format("yyyy-MM-DD")}
                  onChange={(event) => props.handleChange(event)}
                  onBlur={() => props.validateField("incorporationDate")}
                  /> */}
          {/* <div>
                          {" "}
                          <ValidationText
                            error={props.validState.error.incorporationDate}
                          />{" "}
                        </div>
                        <ValidationText
                          error={
                            props.validState.error
                              .incorporationDate
                          }
                        /> */}
          {/* </div> */}

          {/* <div className="xl:col-span-6 md:col-span-6 col-span-12"> */}
          {/* <label
                    className="filter-lable block font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                    htmlFor="default"
                  >
                    Committee Approval Date{" "}
                    <span className="text-[#C00000]">*</span>
                  </label> */}
          {/* <input
                    id="default"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    name="committeeApprovalDate"
                  max={moment(new Date()).format("yyyy-MM-DD")}
                  value={props.taskDetails.committeeApprovalDate ? moment(props.taskDetails.committeeApprovalDate).format("yyyy-MM-DD") : moment(new Date()).format("yyyy-MM-DD")}
                  onChange={(event) => props.handleChange(event)}
                  onBlur={() => props.validateField("incorporationDate")}
                  /> */}
          {/* <div>
                          {" "}
                          <ValidationText
                            error={props.validState.error.incorporationDate}
                          />{" "}
                        </div>
                        <ValidationText
                          error={
                            props.validState.error
                              .incorporationDate
                          } */}
          {/* /> */}
          {/* </div> */}
          {/* </div>
            </div>
          </SectionWithBorder> */}
        </div>

        <div className="grid grid-cols-12 gap-6">
          <div className="2xl:col-span-12 lg:col-span-12 col-span-12 gap-6 pb-10 ">
            <div className="flex items-center justify-between">
              <div className="flex items-center justify-between">
                {props.isLoadingClarification ? (
                  <div className="py-2 w-[250px] btn btn-lighblue text-lg text-white font-bold ">
                    <ButtonLoader className="buttonload group relative rounded-md btn btn-lighblue text-xl text-white focus:outline-none" />
                  </div>
                ) : (
                  <button
                    className={`py-2 w-[250px] btn btn-lighblue text-lg rounded-md text-white font-bold `}
                    // onClick={() => props.sendClarificationMailToMember()}
                    onClick={() => {
                      props.setSendClarificationsFlag();
                    }}
                    disabled={props.statusId === 10}

                  >
                    Send Clarification
                  </button>
                )}
              </div>

              <div className="flex items-center justify-between">
                {props.isLoadingReject ? (
                  <div className="w-[233px] quatation-send-btn">
                    <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none" />
                  </div>
                ) : (
                  <button
                    className={`py-2 w-[250px] btn btn-red col-span-2 text-lg text-xl rounded-md text-white font-bold`}
                    onClick={() => props.rejectApplicationForMember()}
                    disabled={props.statusId === 10}

                  >
                    Reject
                  </button>

                )}
              </div>
              {/* <button
            className={`py-2 w-[250px] btn btn-theme text-lg rounded-md text-white font-bold `}
            // onClick={() => props.sendClarificationMailToMember()}
            onClick={() => {
              props.setWelcomeletterFlag();
            }}
          >
            Welcome letter
          </button> */}

              <div className="flex items-center justify-between">
                {props.isLoadingPayment ? (
                  <div className="w-[233px] quatation-send-btn">
                    <ButtonLoader className="buttonload group relative rounded-md btn btn-red text-xl text-white focus:outline-none" />
                  </div>
                ) : (
                  <button
                    className={`col-end-9 py-2 col-span-2 text-xl rounded-md font-bold text-white btn bg-[#6cbf6c] text-red w-[250px]`}
                    onClick={() => props.sendPaymentLink()}
                    disabled={props.statusId === 10}

                  >
                    Send Payment Link
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/*Footer Button End*/}
        <div className="flex items-center justify-between pb-6">
          <button
            className="text-lg py-2 font-bold btn btn-gray w-auto text-white"
            onClick={() => props.setModalOpen(false)}
          >
            Back
          </button>
        </div>
        {/*Footer Button End*/}
      </div>
    </ModalBasic>
  );
};
export default MembershipTaskListProcess;
